import { getMessageWithPlaceholders } from 'shared-locales';

import type { LocaleMessages, MergeabilityErrorCode } from 'shared-types';

interface Params {
  mergeabilityErrorCode: MergeabilityErrorCode;
  messages: LocaleMessages;
  placeholders?: {
    [key: string]: string | number;
  };
}

/**
 * Reads an error code from the backend and returns a descriptive error message
 * for the user, explaining why the selected course is not compatible
 * with the target course for merging as a language version.
 */
const getCourseMergeabilityErrorMessage = ({
  mergeabilityErrorCode,
  messages,
  placeholders
}: Params) => {
  let message: string | undefined;

  switch (mergeabilityErrorCode) {
    case 'source_course_and_target_course_have_different_amount_of_blocks':
      message =
        messages.courseLanguageVersionsMergeErrorDifferentAmountOfBlocks;
      break;
    case 'source_course_is_missing_a_chapter_from_target_course':
      message = messages.courseLanguageVersionsMergeErrorMissingTargetChapter;
      break;
    case 'target_course_is_missing_a_chapter_from_source_course':
      message = messages.courseLanguageVersionsMergeErrorMissingSourceChapter;
      break;
    case 'source_chapter_and_target_chapter_have_different_amount_of_blocks':
      message =
        messages.courseLanguageVersionsMergeErrorChapterDifferentAmountOfBlocks;
      break;
    case 'source_block_and_target_block_are_not_mergeable':
      message =
        messages.courseLanguageVersionsMergeErrorBlockAndTargetBlockAreNotMergeable;
      break;
    default:
      message = messages.readerErrorDescription;
      break;
  }

  if (message && placeholders) {
    return getMessageWithPlaceholders({ message, placeholders });
  }
  return message;
};

export default getCourseMergeabilityErrorMessage;
